import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_DRAFT_CONFIGURATION, UPDATE_DRAFT_CONFIGURATION_SUCCESS, UPDATE_DRAFT_CONFIGURATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateDraftConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/benefit-type/airport-transfer/configuration/${payload?.data?.id}`,
      method: 'PUT',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_DRAFT_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_DRAFT_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_DRAFT_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchupdateDraftConfiguration() {
  yield takeEvery(UPDATE_DRAFT_CONFIGURATION, updateDraftConfiguration);
}

function* updateDraftConfigurationSaga() {
  yield all([fork(watchupdateDraftConfiguration)]);
}

export default updateDraftConfigurationSaga;
